var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleteForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 7.11328V6.48328C21 5.29028 21 4.69328 20.842 4.21328C20.6982 3.76769 20.4537 3.3612 20.1275 3.0253C19.8013 2.6894 19.4022 2.43311 18.961 2.27628C18.493 2.11328 17.914 2.11328 16.755 2.11328H7.245C6.086 2.11328 5.507 2.11328 5.039 2.27628C4.59793 2.433 4.19885 2.68914 3.87267 3.02487C3.54649 3.36059 3.30195 3.76688 3.158 4.21228C3 4.69428 3 5.29028 3 6.48328V15.1133M21 11.1133V20.4873C21 21.3453 20.015 21.8013 19.392 21.2313C19.2172 21.0698 18.988 20.9801 18.75 20.9801C18.512 20.9801 18.2828 21.0698 18.108 21.2313L17.625 21.6733C17.3188 21.9564 16.9171 22.1137 16.5 22.1137C16.0829 22.1137 15.6812 21.9564 15.375 21.6733C15.0688 21.3901 14.6671 21.2328 14.25 21.2328C13.8329 21.2328 13.4312 21.3901 13.125 21.6733C12.8188 21.9564 12.4171 22.1137 12 22.1137C11.5829 22.1137 11.1812 21.9564 10.875 21.6733C10.5688 21.3901 10.1671 21.2328 9.75 21.2328C9.33293 21.2328 8.93121 21.3901 8.625 21.6733C8.31879 21.9564 7.91707 22.1137 7.5 22.1137C7.08293 22.1137 6.68121 21.9564 6.375 21.6733L5.892 21.2313C5.71721 21.0698 5.48798 20.9801 5.25 20.9801C5.01202 20.9801 4.78279 21.0698 4.608 21.2313C3.985 21.8013 3 21.3453 3 20.4873V19.1133",
    stroke: "#FF395D",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.5133L10.929 12.1133L14.5 8.11328",
    stroke: "#FF395D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.6133H9M16.5 15.6133H12",
    stroke: "#FF395D",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteForm);
export default __webpack_public_path__ + "static/media/completeForm.7f1bb959812878b3cdac403bff32b69f.svg";
export { ForwardRef as ReactComponent };